<template>
  <div class="QuotationEditSuccess" v-title data-title="报价发布成功">
    <van-icon size="100" color="#1989fa" name="checked" />
    <div class="fc-primary">发布成功</div>
    <div class="poster">
      <van-button class="btn-common" type="info"
          @click="createPoster">生成报价单</van-button>
    </div>
    <div class="pt7">
      <van-button class="btn-success" type="default"
          @click="back">返回</van-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import storage from '../../uitls/cacheUtil';

export default Vue.extend({
  name: 'QuotationEditSuccess',
  components: { },
  data() {
    return {

    };
  },
  props: {
    quoteType: {
      type: String,
      default: '1',
    },
  },
  methods: {
    createPoster() {
      this.$router.push({ name: 'QuotationPoster', params: { quoteType: this.quoteType } });
    },
    back() {
      // this.$router.back();
      this.$router.replace(`/quotation/edit?quoteType=${this.quoteType}`);
    },
    logout() {
      storage.local.set('token', '');
      storage.local.set('type', '');
      this.$router.push('/login');
    },
  },
});
</script>
<style scoped>
.QuotationEditSuccess {
  padding-top: 18vh;
  min-height: 100vh;
}
.btn-success {
  width: 60%;
}
.poster {
  padding-top: 13vh;
}
</style>
